import { useEffect } from 'react'
import { createPortal } from 'react-dom'
import { toast } from 'react-toastify'

import { Dialog, Text } from '@loadsmart/miranda-react'

import { RequestStatus } from 'core/domain/Request'

import { useUnassignDriver } from '../hooks/useUnassignDriver'

type UnassignDriverDialogProps = {
  readonly open: boolean
  readonly shipmentUUID: string
  readonly onClose: () => void
  readonly onDriverUnassigned: () => void
}

export function UnassignDriverDialog({
  open,
  shipmentUUID,
  onClose,
  onDriverUnassigned,
}: UnassignDriverDialogProps) {
  const { unassignDriver, requestStatus } = useUnassignDriver()

  useEffect(() => {
    if (requestStatus === RequestStatus.Done) {
      toast.success('Driver unassigned successfully')
      onDriverUnassigned()
      onClose()
    }

    if (requestStatus === RequestStatus.Error) {
      toast.error('Failed to unassign the driver')
    }
  }, [onClose, onDriverUnassigned, requestStatus])

  async function handleSave() {
    unassignDriver({
      shipmentUUID,
    })
  }

  return createPortal(
    <Dialog open={open} data-testid="unassign-driver-dialog" onClose={onClose} variant="danger">
      <Dialog.Header>
        Unassign driver
        <Dialog.Close data-testid="unassign-driver-dialog-close" onClick={onClose} />
      </Dialog.Header>
      <Dialog.Body>
        <Text>
          This action will affect the current tracking being provided to the shipper. Are you sure
          you want to unassign the driver from this load?
        </Text>
      </Dialog.Body>
      <Dialog.Actions>
        <Dialog.ActionTertiary onClick={onClose}>Cancel</Dialog.ActionTertiary>
        <Dialog.ActionPrimary
          onClick={handleSave}
          loading={requestStatus === RequestStatus.Pending}
        >
          Unassign driver
        </Dialog.ActionPrimary>
      </Dialog.Actions>
    </Dialog>,
    document.body,
    'unassign-driver-dialog-root'
  )
}
